<section
  role="dialog"
  aria-modal="true"
  *ngIf="deleteDialog"
  aria-labelledby="modal-title"
  class="inset-0 z-10 fixed overflow-y-auto"
>
  <div class="flex flex-col h-full text-center p-4 items-center justify-center">
    <div
      aria-hidden="true"
      class="bg-gray-500 bg-opacity-75 inset-0 transition-opacity fixed"
    ></div>

    <div
      class="bg-white rounded-lg shadow-xl text-left w-full transform transition-all overflow-hidden sm:max-w-screen-sm sm:my-8"
    >

      <section class="p-8">
        <div class="text-center p-4">{{confirmationText}}</div>

        <nav class="grid pt-4 gap-4 grid-cols-2">
          <button
            (click)="deleteResponse(false)"
            class="bg-white border border-error rounded font-medium text-error text-sm text-center py-2 px-4 block uppercase whitespace-nowrap md:px-8 hover:bg-error/90 hover:text-white"
          >
            Cancel
          </button>

          <button
            (click)="deleteResponse(true)"
            class="bg-primary rounded font-medium text-white text-sm text-center py-2 px-4 block uppercase whitespace-nowrap md:px-8 hover:bg-primary/90"
          >
            Continue
          </button>
        </nav>
      </section>
    </div>
  </div>
</section>
